import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Icon } from '@hz-design-system/web-ui';

import Classes from './Stats.scss';
import { TListingClient } from 'types/TListing';

type TStatsProps = {
  stats: TListingClient['stats'];
};

const Stats = ({ stats }: TStatsProps) => {
  const { favoritedCount, viewCount, since } = stats;
  const { t, date } = useI18nContext();

  return (
    /*
    IMPORTANT: The `aria-label` is on parent element for this group, as Safari browser is summarizing the nested elements
    and not reading them out. This is a workaround for the issue.
    If we are touching this component in the future, the `aria-label` should be updated accordingly.
    */
    <div
      className={Classes.root}
      aria-label={`${t('stats.viewed', { viewCount })} ${t('stats.favorited', { favoritedCount })} ${t('stats.since').concat(date(new Date(since), "D MMM. 'YY, HH:mm"))}`}
    >
      <span className={Classes.stat}>
        <Icon name="eye-open" color="text-secondary" />
        <span className={Classes.summary}>{viewCount}</span>
      </span>

      <span className={Classes.stat}>
        <Icon name="heart" color="text-secondary" />
        <span className={Classes.summary}>{favoritedCount}</span>
      </span>

      <span className={Classes.stat}>
        <Icon name="clock" color="text-secondary" />
        <span className={Classes.summary}>
          <span className={Classes.dateExtra}>{`${t('stats.since')} `}</span>
          {date(new Date(since), "D MMM. 'YY, HH:mm")}
        </span>
      </span>
    </div>
  );
};

export default Stats;
